import { render, staticRenderFns } from "./GatherWorkDetails.vue?vue&type=template&id=614ad24e&scoped=true"
import script from "./GatherWorkDetails.vue?vue&type=script&lang=js"
export * from "./GatherWorkDetails.vue?vue&type=script&lang=js"
import style0 from "./GatherWorkDetails.vue?vue&type=style&index=0&id=614ad24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ad24e",
  null
  
)

export default component.exports